import { useCallback, useEffect } from 'react';

import { toCSV } from 'utils/clickme';
import { ACT_ADVERTISING_SERVICE_TYPES, ACT_PRODUCT_TYPES } from 'utils/constants/admin';
import { FILE_DATE_WITH_TIME_FORMAT, VIEW_DATE_FORMAT } from 'utils/constants/date';
import { formatDate } from 'utils/date';

import useTrls from 'hooks/translation/useTrls';

import InputWithMultiDatePicker from 'components/InputWithMultiDatePicker';

import fetchInvoices from 'components/Admin/Reports/ManualChargesReport/fetchInvoices';
import ManualChargesTable from 'components/Admin/Reports/ManualChargesReport/ManualChargesTable';
import ReportWrapper from 'components/Admin/Reports/ReportWrapper';

import { setDates } from 'store/models/manualCharges';
import { useDispatch, useSelector } from 'store/utils';


const ManualChargesReport = () => {
    const { invoices, isLoad, from, to } = useSelector((state) => state.manualCharges);
    const dispatch = useDispatch();
    const trl = useTrls();

    const onClickCSV = useCallback(() => {
        const currentDate = formatDate(new Date(), FILE_DATE_WITH_TIME_FORMAT);
        const headers = [
            'invoiceId',
            'createdAt',
            'employerId',
            'advertisingServiceType',
            'productType',
            'accountId',
            'number',
            'amount',
            'discountAmount',
            'clicks',
            'bonusClicks',
        ];
        let sumAmount = 0;
        let sumDiscountAmount = 0;
        const invoicesCsv = invoices.map(
            ({
                invoiceId,
                createdAt,
                employerId,
                advertisingServiceType,
                productType,
                accountId,
                userId,
                number,
                amount,
                discountAmount,
                clicks,
                bonusClicks,
            }) => {
                sumAmount += amount;
                sumDiscountAmount += discountAmount;
                return {
                    invoiceId,
                    createdAt: formatDate(createdAt, VIEW_DATE_FORMAT),
                    employerId,
                    advertisingServiceType: trl(ACT_ADVERTISING_SERVICE_TYPES[advertisingServiceType]),
                    productType: trl(ACT_PRODUCT_TYPES[productType]),
                    accountId,
                    number: `${trl('admin.Invoices.InvoicesTable.Invoice.number')}/${userId}/${number}`,
                    amount,
                    discountAmount,
                    clicks,
                    bonusClicks,
                };
            }
        );
        const total = ['', '', '', '', '', '', sumAmount, sumDiscountAmount, '', ''];
        toCSV(`manual_invoice_${currentDate}.csv`, invoicesCsv, headers, total);
    }, [invoices, trl]);

    useEffect(() => {
        dispatch(fetchInvoices());
    }, [dispatch]);

    return (
        <ReportWrapper
            title={trl('admin.SectionTabs.invoiceManual')}
            filter={
                <InputWithMultiDatePicker action={(from, to) => dispatch(setDates({ from, to }))} from={from} to={to} />
            }
            content={<ManualChargesTable />}
            isLoadContent={isLoad}
            onClickSearch={() => dispatch(fetchInvoices())}
            onClickCSV={onClickCSV}
        />
    );
};

export default ManualChargesReport;
